import React from 'react';
import { Card, Row, Spin, Col, Table, Input } from 'antd';
import DetailBar from './components/DetailBar';
import DualAxisChart from '../../../../../shared/charts/DualAxisChart';
import BasketItemDetails from './components/BasketItemDetails';
import moment from 'moment';
import { basketSummaryScale } from '../../utils';
import { PrimaryTableRowText } from '../../../../../shared/globalStyling/styledText';

const LoadingCard = () => {
  return (
    <Card>
      <Row type="flex" justify="center" align="middle">
        <Spin size="large" />
      </Row>
    </Card>
  );
};

const BasketItemsTab = ({
  campaignOrder,
  pageSize,
  basketItemsData,
  basketItemsGroupedOrderId,
  basketItemsGroupedTotalCount,
  currentPage,
  basketItemsDataLoading,
  basketItemsByDate,
  detailBarSummary,
  onDateChange,
  onPageChange,
  expandedRowKeys,
  onExpand,
  searchTerm,
  onSearchChange,
  onSearch,
  basketItemsSearchTerms,
  onBasketItemsSearchChange,
  loading,
}) => {
  if (loading) {
    return <LoadingCard />;
  }

  const dropDownOptions = [
    { key: 'transactions', display: 'Transactions' },
    { key: 'revenue', display: 'Revenue' },
    { key: 'quantity', display: 'Quantity' },
  ];

  return (
    <Card>
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={{ span: 18, order: 1, push: 6 }}>
          <DetailBar data={detailBarSummary} />
        </Col>
        <Col id="basket-items-lg-table" xs={24} lg={{ span: 6 }}>
          <Input.Search
            style={{ margin: '5px 5px' }}
            placeholder="Search basket item by Order Id"
            allowClear
            onSearch={onSearch}
            value={searchTerm}
            onChange={onSearchChange}
          />
          <Table
            rowKey="id"
            columns={[
              {
                title: '',
                dataIndex: 'orderId',
                key: 'orderId',
                align: 'left',
                ellipsis: {
                  showTitle: false,
                },
                render: (text) => <PrimaryTableRowText text={text} />,
              },
            ]}
            style={{ width: '100%' }}
            scroll={{ x: 200 }}
            size="default"
            dataSource={basketItemsGroupedOrderId || []}
            loading={basketItemsDataLoading}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: basketItemsGroupedTotalCount,
              onChange: onPageChange,
              showSizeChanger: false,
              position: ['bottomCenter'],
            }}
            expandable={{
              expandedRowKeys,
              onExpand,
              expandedRowRender: (record) => (
                <div style={{ marginLeft: '3rem' }}>
                  {record.basketItems.map((item, i) => (
                    <div key={i}>
                      <p style={{ fontWeight: 500 }}>{`${i + 1}. ${item.name}`}</p>
                      <p>{`Quantity: ${item.quantity}`}</p>
                      <p>{`Price Per Item: $${item.price}`}</p>
                      <p>{`Total: $${item.total}`}</p>
                    </div>
                  ))}
                </div>
              ),
            }}
          />
        </Col>
        <Col xs={24} lg={{ span: 18, push: 6, order: 2 }}>
          <DualAxisChart
            byDate={basketItemsByDate}
            xAxis="date"
            options={dropDownOptions}
            defaultLeftYValue={dropDownOptions[0]}
            defaultRightYValue={dropDownOptions[1]}
            has6MonDisables={false}
            customScale={basketSummaryScale}
            onDatePickerChange={({ data, dates, rangeKey }) => {
              if (onDateChange) {
                onDateChange(dates);
              }
            }}
            allTimeDateRange={[moment(campaignOrder.startDate), moment(campaignOrder.endDate)]}
          />
        </Col>
        <Col xs={24} lg={{ span: 18, push: 6, order: 3 }}>
          <BasketItemDetails
            basketItems={basketItemsData || []}
            searchTerms={basketItemsSearchTerms}
            onSearchChange={onBasketItemsSearchChange}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default BasketItemsTab;
